interface LoginPromoCardProps {
  title?: string;
  benefits?: string[];
}

export default function LoginPromoCard({ 
  title = "Crea una cuenta para disfrutar de beneficios",
  benefits = [
    "Guarda tus pedidos anteriores",
    "Accede a promociones exclusivas",
  ]
}: LoginPromoCardProps) {
  return (
    <div className="p-4 rounded-xl bg-white border border-[#e9ecef] space-y-2">
      <p className="text-sm leading-5 text-[#22B6B2] font-medium">
        {title}
      </p>

      <ul className="list-disc list-inside">
      {benefits.map((benefit, index) => (
        <li key={index} className="text-sm leading-5 text-[#85929e]">
          {benefit}
        </li>
      ))}
      </ul>
    </div>
  );
} 